<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import DetailedJobPhotosDescListItem from '@/components/items/DetailedJobPhotosDescListItem.vue';

export interface Props {
  photos?: ReadonlyDeep<openapi.GetStopImagesContentOpenapi[0]>;
  deleteImage?: (photoIndex: number) => Promise<void>;
}
const props = withDefaults(defineProps<Props>(), {
  photos: () => [],
  deleteImage: undefined,
});

function getDeleteImageHandler(photoIndex: number) {
  if (!props.deleteImage) return undefined;
  const deleteImageFn = props.deleteImage;
  return () => deleteImageFn(photoIndex);
}
</script>

<template>
  <dl
    :class="$style.detailedJobPhotosDescList"
    data-testid="detailedJobPhotosDescList"
  >
    <template v-for="(photo, photoIndex) in props.photos" :key="photoIndex">
      <DetailedJobPhotosDescListItem
        :class="$style.item"
        :image="photo"
        :delete-image="getDeleteImageHandler(photoIndex)"
      />
    </template>
  </dl>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobPhotosDescList {
  line-height: 1.4;
  font-size: 16px;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  margin: -12px;
}
  .item {
    padding: 12px;
  }
</style>
